// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rpt-sub-table td {
  border: 1px solid black;
  text-align: left;
}
.rpt-sub-table th {
  border: 1px solid black;
  text-align: left;
}
.rpt-sub-header {
  background: rgb(232, 232, 232);
}
.on-off-button {
  line-height: 10px !important;
  font-size: 10px !important;
}
.sub-toggle-button-group > * {
  opacity: 1;
}

.sub-toggle-button-group {
  -webkit-user-select: none !important; /* Chrome all / Safari all */
  -moz-user-select: none !important; /* Firefox all */
  -ms-user-select: none !important; /* IE 10+ */
  user-select: none !important;
  height: 28px;
  margin-top: 3px;
  box-shadow: none !important;
  align-items: center;
  margin-right: 20px;
}
.sub-toggle-button-group .active {
  background: rgba(0, 126, 167, 1) !important;
  color: white !important;
}
.sub-toggle-button-group .btn-check:checked + .btn.sub-toggle-button,
.sub-toggle-button-group .sub-toggle-button.active {
  background-color: #007ea7 !important;
  border-color: #007ea7 !important;
  color: white !important;
  box-shadow: none !important;
}
.sub-toggle-button {
  font-size: 13px !important;
  /* padding-left: 6px !important;
  padding-right: 6px !important;
  padding-top: 6px !important;
  padding-bottom: 7px !important; */
  min-width: 23px !important;
  background-color: white;
  border: 1px solid rgba(88, 89, 91, 1);
  color: black;
  cursor: pointer;
  line-height: 14px !important;
  height: 28px;
  box-shadow: none !important;
}
.sub-toggle-button-group .btn.sub-toggle-button:hover {
  background-color: #38a6cb !important;
  color: white !important;
  border: 1px solid #38a6cb !important;
}

.sub-toggle-button-group .btn-check:checked + .btn.sub-toggle-button:hover,
.sub-toggle-button-group .sub-toggle-button.active:hover {
  background-color: #007ea7 !important;
  border-color: #007ea7 !important;
  color: white !important;
}
/* .btn-primary {
  background-color: white !important;
}

.btn-primary:focus {
  box-shadow: none !important;
} */

.sub-toggle-button:focus {
  outline: none;
  box-shadow: none !important;
}
.button-override {
  /* background-color: rgb(126, 126, 126); */
  color: black !important;
}
.button-override::after {
  opacity: 0 !important;
}
.daily-select-group {
  display: flex;
  flex-direction: row;
  margin-right: 10px;
}

.run-now-btn {
  border: 1px solid black;
  margin-left: 20px;
  padding: 2px 4px 2px 4px;
  font-size: 14px;
  height: 28px;
  margin-top: 3px;
  cursor: pointer;
  border-radius: 3px;
  margin-right: 20px;
}

.run-now-btn-disabled {
  pointer-events: none;
}

.rpt-sub-modal .modal-content {
  width: 105%;
}
`, "",{"version":3,"sources":["webpack://./src/components/reportSubscriptions/components/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC,EAAE,4BAA4B;EAClE,iCAAiC,EAAE,gBAAgB;EACnD,gCAAgC,EAAE,WAAW;EAC7C,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,uBAAuB;AACzB;AACA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B;;;mCAGiC;EACjC,0BAA0B;EAC1B,uBAAuB;EACvB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;AACA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,0CAA0C;EAC1C,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".rpt-sub-table td {\n  border: 1px solid black;\n  text-align: left;\n}\n.rpt-sub-table th {\n  border: 1px solid black;\n  text-align: left;\n}\n.rpt-sub-header {\n  background: rgb(232, 232, 232);\n}\n.on-off-button {\n  line-height: 10px !important;\n  font-size: 10px !important;\n}\n.sub-toggle-button-group > * {\n  opacity: 1;\n}\n\n.sub-toggle-button-group {\n  -webkit-user-select: none !important; /* Chrome all / Safari all */\n  -moz-user-select: none !important; /* Firefox all */\n  -ms-user-select: none !important; /* IE 10+ */\n  user-select: none !important;\n  height: 28px;\n  margin-top: 3px;\n  box-shadow: none !important;\n  align-items: center;\n  margin-right: 20px;\n}\n.sub-toggle-button-group .active {\n  background: rgba(0, 126, 167, 1) !important;\n  color: white !important;\n}\n.sub-toggle-button-group .btn-check:checked + .btn.sub-toggle-button,\n.sub-toggle-button-group .sub-toggle-button.active {\n  background-color: #007ea7 !important;\n  border-color: #007ea7 !important;\n  color: white !important;\n  box-shadow: none !important;\n}\n.sub-toggle-button {\n  font-size: 13px !important;\n  /* padding-left: 6px !important;\n  padding-right: 6px !important;\n  padding-top: 6px !important;\n  padding-bottom: 7px !important; */\n  min-width: 23px !important;\n  background-color: white;\n  border: 1px solid rgba(88, 89, 91, 1);\n  color: black;\n  cursor: pointer;\n  line-height: 14px !important;\n  height: 28px;\n  box-shadow: none !important;\n}\n.sub-toggle-button-group .btn.sub-toggle-button:hover {\n  background-color: #38a6cb !important;\n  color: white !important;\n  border: 1px solid #38a6cb !important;\n}\n\n.sub-toggle-button-group .btn-check:checked + .btn.sub-toggle-button:hover,\n.sub-toggle-button-group .sub-toggle-button.active:hover {\n  background-color: #007ea7 !important;\n  border-color: #007ea7 !important;\n  color: white !important;\n}\n/* .btn-primary {\n  background-color: white !important;\n}\n\n.btn-primary:focus {\n  box-shadow: none !important;\n} */\n\n.sub-toggle-button:focus {\n  outline: none;\n  box-shadow: none !important;\n}\n.button-override {\n  /* background-color: rgb(126, 126, 126); */\n  color: black !important;\n}\n.button-override::after {\n  opacity: 0 !important;\n}\n.daily-select-group {\n  display: flex;\n  flex-direction: row;\n  margin-right: 10px;\n}\n\n.run-now-btn {\n  border: 1px solid black;\n  margin-left: 20px;\n  padding: 2px 4px 2px 4px;\n  font-size: 14px;\n  height: 28px;\n  margin-top: 3px;\n  cursor: pointer;\n  border-radius: 3px;\n  margin-right: 20px;\n}\n\n.run-now-btn-disabled {\n  pointer-events: none;\n}\n\n.rpt-sub-modal .modal-content {\n  width: 105%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
